import React from 'react';
import SgsstCrudPage from '../components/SgsstCrudPage';
import { sgsstPermisos } from '../services/api';

const hoy = () => new Date().toISOString().slice(0, 10);
const TIPO = { alturas: 'Trabajo en alturas', espacio_confinado: 'Espacio confinado', trabajo_caliente: 'Trabajo en caliente', energia_peligrosa: 'Energías peligrosas', excavacion: 'Excavación', otro: 'Otro' };
const ESTADO = { abierto: 'Abierto', cerrado: 'Cerrado', cancelado: 'Cancelado' };

export default function SgsstPermisos() {
  return (
    <SgsstCrudPage
      title="Permisos de trabajo"
      sub="Autorizaciones para tareas de alto riesgo."
      newLabel="+ Nuevo permiso"
      api={sgsstPermisos}
      vacio={{ tipo: 'alturas', fecha: hoy(), lugar: '', descripcion: '', responsable: '', trabajadores: '', valido_desde: '', valido_hasta: '', medidas: '', estado: 'abierto' }}
      columns={[
        { k: 'consecutivo', h: '#', mono: true }, { k: 'fecha', h: 'Fecha', fmt: 'date' }, { k: 'tipo', h: 'Tipo', map: TIPO, strong: true },
        { k: 'lugar', h: 'Lugar' }, { k: 'responsable', h: 'Responsable' }, { k: 'estado', h: 'Estado', map: ESTADO },
      ]}
      fields={[
        { k: 'tipo', l: 'Tipo de trabajo', type: 'select', opts: Object.entries(TIPO) }, { k: 'fecha', l: 'Fecha', type: 'date' },
        { k: 'lugar', l: 'Lugar', type: 'text', full: true }, { k: 'descripcion', l: 'Descripción de la tarea', type: 'textarea', full: true },
        { k: 'responsable', l: 'Responsable', type: 'text' }, { k: 'trabajadores', l: 'Trabajadores autorizados', type: 'text' },
        { k: 'valido_desde', l: 'Válido desde', type: 'datetime' }, { k: 'valido_hasta', l: 'Válido hasta', type: 'datetime' },
        { k: 'medidas', l: 'Medidas de control', type: 'textarea', full: true }, { k: 'estado', l: 'Estado', type: 'select', opts: Object.entries(ESTADO) },
      ]}
    />
  );
}
